import { useQueryData } from "@src/hooks/useQueryData";
import { arrayIsEmpty } from "@src/helpers/array/arrayIsEmpty";
import { limitCardsServices, type LeaveLimitCard } from "@src/api/stock/limitCards";

/**
 * Загрузка детальной карточки отпуска ЛК.
 */
export function useWsLimitCardLeaveQuery(leaveCode: number) {
    return useQueryData<LeaveLimitCard>({
        queryKey: ["workshop", "wsLimitCard", "leave", leaveCode],
        queryFn: async () => {
            const { items } = await limitCardsServices.leave.load({
                flt: { Codes: [leaveCode] },
                include: ["Bo", "LimitCardContent"],
                includeBo: ["State"],
                includeLimitContent: ["StockObj", "MeasMain"],
            });

            if (arrayIsEmpty(items)) {
                throw new Error(`Не найден отпуск ЛК с кодом ${leaveCode}`);
            }

            return items[0];
        },
        enabled: leaveCode > 0,
        meta: { errorSource: "workshop.wsLimitCard.leave" },
    });
}
